// "Embedded" mode: the native app opens the web checkout inside an in-app
// browser with ?app=1. In that case we hide the site chrome (navbar + footer)
// so the checkout looks like a native screen. The flag is persisted to
// sessionStorage because it's set on /destinations and must survive the
// client-side navigation to /checkout.
export const isEmbedded = () => {
  try {
    const p = new URLSearchParams(window.location.search);
    if (p.get('app') === '1') sessionStorage.setItem('cf_embedded', '1');
    return sessionStorage.getItem('cf_embedded') === '1';
  } catch {
    return false;
  }
};

// The native app passes a return URL (its own deep link). On payment success we
// send the in-app browser there so it auto-closes and the app lands on My eSIMs.
export const getReturnUrl = () => {
  try {
    const p = new URLSearchParams(window.location.search);
    const r = p.get('return');
    if (r) sessionStorage.setItem('cf_return', r);
    return sessionStorage.getItem('cf_return') || null;
  } catch {
    return null;
  }
};
